module.exports = __webpack_public_path__ + "static/media/dry-cleaning.76229519.svg";